import { PropsWithChildren } from 'react'
import { Box } from '@machobear/design-system'

export const PageContentLeft = ({ children }: PropsWithChildren) => (
  <Box display="flex" flexDirection="column" gap="large" style={{ flexGrow: 0 }}>
    {children}
  </Box>
)

export const PageContentRight = ({ children }: PropsWithChildren) => (
  <Box display="flex" flexDirection="column" gap="large" style={{ flexGrow: 1, maxWidth: '800px' }}>
    {children}
  </Box>
)

export const PageContent = ({ children }: PropsWithChildren) => (
  <Box
    display="flex"
    flexDirection="row"
    gap="xlarge"
    width="full"
    background="neutralLight"
    paddingX={{ mobile: 'none', tablet: 'xxxlarge' }}
    paddingY={{ mobile: 'gutter', desktop: 'xlarge' }}
  >
    {children}
  </Box>
)
